import { ChangeEvent, FC, FocusEventHandler, memo } from 'react'
import { PlanningClassification } from '@leadgen/models/client'
import { CheckboxButton } from '../../../atoms/CheckboxButton'
import { planningClassificationMap } from '../../../../constants/planningTaxonomy'
import useStableCallback from '../../../../hooks/shared/useStableCallback'

const ClassificationTile: FC<{
  planningClassification: PlanningClassification
  selected: boolean
  onChange: (planningClassification: PlanningClassification, checked: boolean) => void
  onBlur?: FocusEventHandler<HTMLButtonElement>
}> = ({ planningClassification, selected, onChange, onBlur }) => {
  const onClassificationChange = useStableCallback(
    (_event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      onChange(planningClassification, checked)
    },
  )
  return (
    <CheckboxButton
      onBlur={onBlur}
      onChange={onClassificationChange}
      value={planningClassification}
      checked={selected}
      label={planningClassificationMap[planningClassification].title}
      tooltip={planningClassificationMap[planningClassification].description}
      variant="compact"
    />
  )
}

export default memo(ClassificationTile)
